import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import axios from "axios";
import { Link, navigate } from 'raviger';
import { Form, Formik } from 'formik';
import { Button, Col, ListGroup, Modal, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBan, faBandAid, faBullseye, faCar, faCheckCircle, faChevronDown, faChevronUp, faEquals, faExclamationTriangle, faCircle, faClipboardList, faExclamationCircle, faQuestionCircle, faPlusSquare, faTrailer, faUserAlt, faUserAltSlash, faExclamation, faFilter,
  faLink, faReply
} from '@fortawesome/free-solid-svg-icons';
import { faHandsHolding, faBarsSort, faChevronDoubleDown, faChevronDoubleUp, faCircleBolt, faHomeAlt, faLocationCrosshairs, faLocationQuestion, faRotate, faClawMarks } from '@fortawesome/pro-solid-svg-icons';
import { faHomeAlt as faHomeAltReg, faCalendarExclamation } from '@fortawesome/pro-regular-svg-icons';
import { faQuestionCircle as faQuestionCircleDuo } from '@fortawesome/pro-duotone-svg-icons';
import { Circle, Marker, Tooltip as MapTooltip } from "react-leaflet";
import MarkerClusterGroup from 'react-leaflet-cluster';
import L from "leaflet";
import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';
import { styled } from '@mui/styles';
import Switch from '@mui/material/Switch';
import { Typeahead } from 'react-bootstrap-typeahead';
import Moment from 'react-moment';
import moment from 'moment';
import Map, { countMatches, prettyText, createReportedEvacMarkerIcon, createReportedSIPMarkerIcon, createSIPMarkerIcon, createUTLMarkerIcon, createCheckMarkerIcon, createGrayCheckMarkerIcon, createOperationsMarkerIcon, createReturnRequestedMarkerIcon, createReportedMarkerIcon } from "../components/Map";
import { Checkbox, DateRangePicker, Radio, TextInput, ToggleSwitch } from "../components/Form";
import { DispatchDuplicateSRModal, DispatchAlreadyAssignedTeamModal } from "../components/Modals";
import Scrollbar from '../components/Scrollbars';
import Header from '../components/Header';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'leaflet/dist/leaflet.css';
import { FieldTeamMemberModal } from './Modals';
import { capitalize, altStatusLabelLookup } from '../utils/formatString';
import { priorityChoices, unknownChoices } from '../constants';
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';

const PrettySlider = styled(Slider)({
  height: 8,
  '& .MuiSlider-track': {
    border: 'none',
    height: 9,
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-rail': {
    height: 5,
    opacity: 0.5,
    boxShadow: 'inset 0px 0px 4px -2px #000',
    backgroundColor: '#d0d0d0',
  },
  '& .MuiSlider-valueLabel': {
    marginLeft: 0,
  },
  '& .MuiSlider-markLabel': {
    color: 'white',
  },
});

function UpdateableMarker({ checked, ...props }) {

  const markerRef = useRef(null);

  useEffect(() => {
    // This effect runs when the icon prop changes, updating the Leaflet marker
    if (markerRef.current) {
      markerRef.current.setIcon(checked.includes(props.service_request.id) ? props.checkMarkerIcon : props.initialIcon);
    }
  }, [props.initialIcon, checked]);

  const eventHandlers = useMemo(
    () => ({
      click: (e) => {
        if (props.handleMapState) {
          props.handleMapState(e, props.service_request.id);
        }
      },
    }),
    [] // Empty dependency array means this object is created only once
  )

  return useMemo(() => (
    <Marker
      position={props.position}
      eventHandlers={eventHandlers}
      zIndexOffset={1000}
      ref={markerRef}
    >
      {props.children}
    </Marker>
  ), []);
}

function Deploy({ incident, organization }) {

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  const openStartRef = useRef(null);
  const openEndRef = useRef(null);
  const mapRef = useRef(null);

  const [data, setData] = useState({service_requests: [], isFetching: true, bounds:null});
  const [newData, setNewData] = useState(false);
  const [mapState, setMapState] = useState({});
  const [bounds, setBounds] = useState([]);
  const [checked, setChecked] = useState([]);
  const [totalSelectedState, setTotalSelectedState] = useState({'ids':[], 'ANIMALLESS':{}, 'REPORTED':{}, 'REPORTED (EVAC REQUESTED)':{}, 'REPORTED (SIP REQUESTED)':{}, 'SHELTERED IN PLACE':{}, 'UNABLE TO LOCATE':{}, 'TRANSPORT REQUESTED':{}});
  const [selectedCount, setSelectedCount] = useState({count:0, disabled:true, ids:[]});
  const [triggerRefresh, setTriggerRefresh] = useState(false);
  const [teamData, setTeamData] = useState({teams: [], members:[], options: [], isFetching: false});
  const [selected, setSelected] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [assignedTeamMembers, setAssignedTeamMembers] = useState([]);
  const [showAddTeamMember, setShowAddTeamMember] = useState(false);
  const handleCloseShowAddTeamMember = () => setShowAddTeamMember(false);
  const [sortChoice, setSortChoice] = useState('followup_date');
  const [filterData, setFilterData] = useState({priority:[], species:[], status:[], turn_around:[], trailer_required:[], accessible:[], injured:[], aggressive:[], confined:[], animal_count:[0,0], verbal: null, followup_date_start:null, followup_date_end:null, special_handling:false, verbal_permission:false, medical_record:false, support_sr:false});
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [optionFilter, setOptionFilter] = useState('request');
  const [showFilterModal, setShowFilterModal] = useState(false);
  const handleCloseFilterModal = () => setShowFilterModal(false);
  const [showSortModal, setShowSortModal] = useState(false);
  const handleCloseSortModal = () => setShowSortModal(false);
  const [showLegendModal, setShowLegendModal] = useState(false);
  const handleCloseLegendModal = () => setShowLegendModal(false);
  const [showDispatchDuplicateSRModal, setShowDispatchDuplicateSRModal] = useState(false);
  const [duplicateSRs, setDuplicateSRs] = useState([]);
  const handleCloseDispatchDuplicateSRModal = () => {setDuplicateSRs([]);setShowDispatchDuplicateSRModal(false);}
  const [showAlreadyAssignedTeamModal, setShowAlreadyAssignedTeamModal] = useState(false);
  const handleCloseAlreadyAssignedTeamModal = () => {setDuplicateSRs([]);setShowAlreadyAssignedTeamModal(false);}
  const [proceed, setProceed] = useState(false);
  const [speciesChoices, setSpeciesChoices] = useState([]);
  // const [speciesCategoryChoices, setSpeciesCategoryChoices] = useState([]);
  const [species, setSpecies] = useState([]);
  const [marks, setMarks] = useState([{value: 0, label: '0'}, {value: 100, label: '100+'}]);
  const [reportedMarkerIcon, setReportedMarkerIcon] = useState(createReportedMarkerIcon(13));
  const [reportedEvacMarkerIcon, setReportedEvacMarkerIcon] = useState(createReportedEvacMarkerIcon(13));
  const [reportedSIPMarkerIcon, setReportedSIPMarkerIcon] = useState(createReportedSIPMarkerIcon(13));
  const [SIPMarkerIcon, setSIPMarkerIcon] = useState(createSIPMarkerIcon(13));
  const [UTLMarkerIcon, setUTLMarkerIcon] = useState(createUTLMarkerIcon(13));
  const [returnRequestedMarkerIcon, setReturnRequestedMarkerIcon] = useState(createReturnRequestedMarkerIcon(13));
  const [checkMarkerIcon, setCheckMarkerIcon] = useState(createCheckMarkerIcon(13));
  const [grayCheckMarkerIcon, setGrayCheckMarkerIcon] = useState(createGrayCheckMarkerIcon(13));
  const [operationsMarkerIcon, setOperationsMarkerIcon] = useState(createOperationsMarkerIcon(13));

  const priorityText = {1:'Urgent', 2:'High', 3:'Medium', 4:'Low', 5:'Lowest'};

  const createCustomClusterIcon = (cluster) => {
    const map = mapRef.current
    let zoom = map.getZoom();
    const count = cluster.getChildCount();
    let clusterSizeClass = 'marker-cluster marker-cluster-small';
    if (zoom >= 16 && zoom < 17) {
      clusterSizeClass = 'marker-cluster marker-cluster-medium';
    } else if (zoom >= 17) {
      clusterSizeClass = 'marker-cluster marker-cluster-large';
    }

    return L.divIcon({
      html: `<span>${count}</span>`,
      className: clusterSizeClass, // Add a custom CSS class for styling
      iconSize: [0, 0],
      iconAnchor: [8, 9], // Adjust anchor to center the icon
    });
  };

  function getAriaValueText(value) {
    return Number(value) === 100 ? `${value}+` : value;
  }

  const handleAnimalCountChange = (event, newValue) => {
    setMarks([{value: newValue[0], label: newValue[0]}, {value: newValue[1], label: newValue[1] === 100 ? '100+' : newValue[1]}])
    setFilterData((prevState) => ({...prevState, animal_count:newValue}))
  };

  // Handle radius circle toggles.
  const handleRadius = (id) => {
    if (mapState[id].radius === "disabled") {
      setMapState(prevState => ({ ...prevState, [id]: {...prevState[id], "radius":"enabled"} }));
    }
    else {
      setMapState(prevState => ({ ...prevState, [id]: {...prevState[id], "radius":"disabled"} }));
    }
  }

  // Handle TeamMember selector onChange.
  const handleChange = (values, props) => {
    let id_list = [];
    let selected_list = [];
    values.forEach(value => {
      id_list = [...id_list, ...value.id];
      // Handle if Team.
      if (value.label.split(':').length > 1) {
        setSelectedTeam(value.da_id);
        selected_list.push({id:value.id, da_id:value.da_id, label:value.label, is_assigned:value.is_assigned});
      }
      // Else handle as an individual TeamMember.
      else {
        setSelectedTeam(null);
        selected_list.push({id:value.id, da_id:value.da_id, label:value.label, is_assigned:value.is_assigned});
      }
    });

    // If deselecting.
    if (selected.length > selected_list.length) {
      let team_options = [];
      setSelectedTeam(null);
      // Add back teams if the select list is empty.
      if (selected_list.length === 0) {
        teamData.teams.forEach(function(team) {
            team_options.unshift({id:team.team_object.team_members, da_id:team.id, label:"FA#" + team.id_for_incident + (team.team_object.name ? " (" + team.team_object.name + "): " : ": ") + team.team_object.display_name, is_assigned:team.team_object.is_assigned});
        });
      }
      teamData.members.forEach(function(member) {
        // Add selectable options back if if not already available.
        team_options.push({id:[member.id], da_id:null, label:member.display_name, is_assigned:member.is_assigned});
      });
      setTeamData(prevState => ({ ...prevState, "options":team_options }));
      setSelectedCount((prevState) => ({...prevState, disabled: (prevState.count > 0 ? false : true)}));
    }
    // Else we're selecting. Remove selection from option list.
    else {
      // Remove other options if we've selected a team.
      if (values.filter(value => value.label.includes(':')).length) {
        setTeamData(prevState => ({ ...prevState, "options":[] }));
      }
      else {
        setTeamData(prevState => ({ ...prevState, "options":teamData.options.filter(option => (!id_list.includes(option.id[0])) && (option.da_id === null)) }));
      }
    }
    props.setFieldValue('team_members', id_list);
    setSelected(selected_list);
  }

  // Handle reselecting after hitting dupe assigned SR error.
  const handleReselect = async event => {
    // Perform API update for most recent data and clean out the duplicate SRs.
    setTriggerRefresh(!triggerRefresh)
    setMapState(Object.keys(mapState).filter(key => !duplicateSRs.includes(key))
      .reduce((obj, key) => {
        obj[key] = mapState[key];
        return obj;
      }, {})
    );
    setDuplicateSRs([]);
    setShowDispatchDuplicateSRModal(false);
  }

  function selectSR(total_selected, id) {
    let status_matches = {};
    let total = 0;
    // Add each match count to the running total state tracker.
    for (var select_status in mapState[id].status_matches) {
      let matches = {...total_selected[select_status]};
      for (var select_key in mapState[id].status_matches[select_status]){
        if (!total_selected[select_status][select_key]) {
          total = mapState[id].status_matches[select_status][select_key];
        } else {
          total = total_selected[select_status][select_key] += mapState[id].status_matches[select_status][select_key];
        }
        matches[select_key] = total;
      }
      status_matches[select_status] = matches;
    }
    return status_matches
  }

  function deselectSR(total_selected, id) {
    let remove_status_matches = {};
    let remove_total = 0;
    // Remove each match count from the running total state tracker.
    for (var status in mapState[id].status_matches) {
      let remove_matches = {...total_selected[status]};
      for (var key in mapState[id].status_matches[status]) {
        remove_total = total_selected[status][key] -= mapState[id].status_matches[status][key];
        if (remove_total === 0) {
          delete remove_matches[key]
        }
        else {
          remove_matches[key] = remove_total;
        }
      }
      remove_status_matches[status] = remove_matches;
    }
    return remove_status_matches
  }

  // Handle dynamic SR state and map display when an SR is selected or deselected.
  const handleMapState = (e, id) => {
    // If selected.
    setChecked((prevState) => prevState.includes(id) ? prevState.filter(check => check !== id) : [...prevState, id]);
    setTotalSelectedState((prevState) => prevState['ids'].includes(id) ? {...Object.assign(totalSelectedState, deselectSR(prevState, id)), ids:prevState['ids'].filter(check => check !== id)} : {...Object.assign(totalSelectedState, selectSR(prevState, id)), ids:[...prevState['ids'], id]});
    setSelectedCount((prevState) => (prevState['ids'].includes(id) ? {count: prevState.count - 1, disabled: prevState.count-1 === 0, ids:prevState['ids'].filter(check => check !== id)} : {count: prevState.count + 1, disabled: false, ids:[...prevState['ids'], id]}))
  }

  // Show or hide list of SRs based on current map zoom
  const onMove = useCallback((event) => {
    let tempMapState = {...mapState};
    for (const service_request_id of Object.keys(mapState)) {
      if (!event.target.getBounds().contains(L.latLng(mapState[service_request_id].latitude, mapState[service_request_id].longitude))) {
        tempMapState[service_request_id].hidden=true;
      }
      else {
        tempMapState[service_request_id].hidden=false;
      }
    }
    setMapState(tempMapState);
  }, [mapState, setMapState])

  const isFollowupDateBeforeToday = (followupDate) => {
    if (!followupDate) return false;
    const [year, month, day] = followupDate.split('-').map(Number);
    const followup = new Date(year, month - 1, day);
    const today = new Date();
    followup.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return followup < today;
  };

  // Locally working websocket connection.
  // TODO: bring back?
  // useWebSocket('ws://' + window.location.host.replace('localhost:3000', 'localhost:8000') + '/ws/map_data/', {
  //   onMessage: (e) => {
  //     setNewData(true)
  //   },
  //   shouldReconnect: (closeEvent) => true,
  // });

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchSpecies = () => {
      setSpeciesChoices([]);
      // Fetch Species data.
      axios.get('/animals/api/species/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let species_options = [];
          response.data.forEach(result => {
            // Build species option list.
            species_options.push({value: result.name, label: capitalize(result.name)});
          });
          setSpecies(response.data);
          Array.from(new Set(response.data.map(result => result.category))).forEach(result => {
            species_options.push({value: result, label: capitalize(result)});
          })
          setSpeciesChoices(species_options.sort(function (a,b) {if (a.value < b.value){ return -1} if (a.value > b.value) {return 1} return 0;}).filter((v, i, a) => a.findIndex(t => (t.value === v.value)) === i)); //.sort
          fetchServiceRequests(response.data);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      });
    };
    fetchSpecies();

    const fetchTeamMembers = async () => {
      setTeamData({teams: [], options: [], isFetching: true});
      // Fetch all TeamMembers.
      await axios.get('/evac/api/evacteammember/?incident=' + incident + '&organization=' + organization, {
        cancelToken: source.token,
      })
      .then(async (memberResponse) => {
        if (!unmounted) {
          let options = [];
          memberResponse.data.filter(teammember => teammember.show === true).forEach(function(teammember) {
            options.push({id:[teammember.id], da_id:null, label:teammember.display_name, is_assigned:teammember.is_assigned})
          });
          setAssignedTeamMembers(memberResponse.data.filter(teammember => teammember.is_assigned === true).map(teammember => teammember.id))
          // Then fetch all recent Teams.
          let dispatch_assignments = [];
          let nextUrl = '/evac/api/evacassignment/?page=1&page_size=100';
          do {
            const response = await axios.get(nextUrl, {
              params: {
                deploy_map: true,
                incident,
                status: 'open',
                organization,
              },
              cancelToken: source.token,
            })
            .catch(error => {
              if (error.response) {
                setShowSystemError(true);
              }
            });
            if (response) {
              response.data.results.forEach(function(da) {
                options.unshift({
                  id: da.team_object.team_members,
                  da_id: da.id,
                  label: `FA#${da.id_for_incident}${
                    da.team_object.name ? ` (${da.team_object.name})` : ""
                  }: ${
                    da.team_object.team_members && da.team_object.team_members.length > 0
                      ? da.team_object.display_name
                      : "No Team Members Assigned"
                  }`,
                  is_assigned: da.team_object.is_assigned
                });
              });
              dispatch_assignments.push(...response.data.results);
              nextUrl = response.data.next;
              if (nextUrl) {
                nextUrl = '/evac/' + response.data.next.split('/evac/')[1];
              }
            }
            else {
              nextUrl = null
            }
          } while(nextUrl != null)
          setTeamData({teams:dispatch_assignments, members:memberResponse.data, options:options, isFetching:false});
        }
      })
    };

    const fetchServiceRequests = async (species_data) => {
      setData({...data, isFetching: true});
      let service_requests = [];
      const map_dict = {...mapState};
      let bounds_copy = [...bounds];
      let nextUrl = '/hotline/api/servicerequests/?page=1&page_size=100&incident=' + incident + '&organization=' + organization;
      if (!unmounted) {
        do {
          const response = await axios.get(nextUrl, {
            params: {
            status: 'open',
            landingmap: true
          },
            cancelToken: source.token,})
          .catch(error => {
            if (error.response) {
              setShowSystemError(true);
            }
          });
          const current_ids = Object.keys(mapState);
          for (const service_request of response.data.results) {
            // Only add initial settings if we don't already have them.
            if (!current_ids.includes(String(service_request.id))) {
              if (Object.keys(mapState).length >= 1) {
                setNewData(true);
                setTimeout(() => {
                  setNewData(false);
                }, 3000);
              }
              const total_matches = countMatches(service_request.animals, species_data);
              const matches = total_matches[0];
              const status_matches = service_request.animals.filter(animal => !['REUNITED', 'DECEASED', 'CARE TRANSFERRED', 'NO FURTHER ACTION'].includes(animal.status)).length ? total_matches[1] : {'ANIMALLESS':{animalless:1}};
              const color = service_request.reported_animals > 0 ? '#ff4c4c' : service_request.sheltered_in_place > 0 ? '#f5ee0f' : '#5f5fff';
              map_dict[service_request.id] = {hidden:false, color:color, matches:matches, status_matches:status_matches, radius:"disabled", latitude:service_request.latitude, longitude:service_request.longitude};
              bounds_copy.push([service_request.latitude, service_request.longitude]);
            }
          }
          service_requests.push(...response.data.results);
          nextUrl = response.data.next;
          if (nextUrl) {
            nextUrl = '/hotline/' + response.data.next.split('/hotline/')[1];
          }
        } while(nextUrl != null)
        setData(prevState => ({ ...prevState, service_requests: service_requests, isFetching: false, "bounds":bounds_copy}));
        setMapState(map_dict);
        setBounds(bounds_copy);

        var status_matches = {'ids':checked, 'ANIMALLESS':{}, 'REPORTED':{}, 'REPORTED (EVAC REQUESTED)':{}, 'REPORTED (SIP REQUESTED)':{}, 'SHELTERED IN PLACE':{}, 'UNABLE TO LOCATE':{}, 'TRANSPORT REQUESTED':{}};
        var matches = {};
        var total = 0;
        // Recount the total state tracker for selected SRs on refresh.
        Object.keys(map_dict).filter(key => checked.includes(key) && service_requests.map(sr => sr.id).includes(Number(key))).forEach(id => {
          for (var select_status in map_dict[id].status_matches) {
            matches = {...status_matches[select_status]};
            for (var select_key in map_dict[id].status_matches[select_status]){
              if (!status_matches[select_status][select_key]) {
                total = map_dict[id].status_matches[select_status][select_key];
              } else {
                total = status_matches[select_status][select_key] += map_dict[id].status_matches[select_status][select_key];
              }
              matches[select_key] = total;
            }
            status_matches[select_status] = matches;
          }
        })
        setTotalSelectedState(status_matches);
      }
    };

    // Only fetch team member data first time.
    // or after triggering a refresh
    if (teamData.options.length === 0 || triggerRefresh) {
      fetchTeamMembers();
    }

    setNewData(false);

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [triggerRefresh, incident]);

  return (
    <Formik
      initialValues={{
        da_id: selectedTeam,
        team_members: [],
        service_requests: [],
        incident: state.incident.id,
        incident_slug: incident,
        organization_slug: organization,
        special_handling: false,
      }}
      enableReinitialize={true}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        // Check if assigned team members have been submitted.
        if (!proceed && values.team_members.filter(teammember => (assignedTeamMembers.includes(teammember))).map(teammember => teammember).length > 0) {
          setShowAlreadyAssignedTeamModal(true);
          // Re-enable the deploy button so the user can reselect and resubmit.
          setSubmitting(false);
        }
        else {
          values.service_requests = Object.keys(mapState).filter(key => checked.includes(Number(key)));
          // Remove duplicate assignments from POST values.
          if (duplicateSRs.length > 0) {
            values.service_requests = values.service_requests.filter(sr_id => !duplicateSRs.includes(sr_id));
          }
          setTimeout(() => {
            if (selectedTeam) {
              let promises = [];
              values.service_requests.forEach((sr_id) => {
                promises.push(axios.patch('/evac/api/evacassignment/' + selectedTeam + '/', {new_service_request:sr_id}));
              });
              Promise.all(promises).then(async (results) => {
                navigate('/' + organization + '/' + incident + '/field/summary/' + results[0].data.id_for_incident);
              })
              .catch(error => {
                setShowSystemError(true);
              });
            }
            else {
              axios.post('/evac/api/evacassignment/', values)
              .then(response => {
                navigate('/' + organization + "/" + incident + '/field/summary/' + response.data.id_for_incident);
                // Historical Active vs Preplan Logic.
                // Stay on map and remove selected SRs if in Preplanning mode.
                // if (values.team_members.length === 0 && selectedCount.count > 0) {
                //   setSelectedCount({count:0, disabled:true});
                //   const newState = {...mapState};
                //   values.service_requests.forEach(sr => {
                //     delete newState[sr];
                //   })
                //   setMapState(newState);
                //   resetForm();
                //   setTriggerRefresh(!triggerRefresh);
                // }
                // // Otherwise navigate to the DA Summary page.
                // else {
                //   navigate('/' + organization + "/" + incident + '/field/summary/' + response.data.id_for_incident);
                // }
              })
              .catch(error => {
                if (error.response.data && error.response.data[0].includes('Duplicate assigned service request error')) {
                  setDuplicateSRs(error.response.data[1]);
                  setShowDispatchDuplicateSRModal(true);
                }
                else {
                  setShowSystemError(true);
                }
              });
            }
            setSubmitting(false);
          }, 500);
        }
      }}
    >
    {props => (
      <Form>
        <Header>
          Deploy Teams&nbsp;
          <OverlayTrigger
            key={"new-data"}
            placement="bottom"
            overlay={
              <Tooltip id={`tooltip-new-data`}>
                {"Refresh service request data."}
              </Tooltip>
            }
          >
            <span className="d-inline-block">
              <Button id="refresh" className="fa-move-up" onClick={() => setTriggerRefresh(!triggerRefresh)} disabled={data.isFetching || newData} style={{width:"40px"}}>
                <FontAwesomeIcon icon={newData ? faExclamation : faRotate} />
              </Button>
            </span>
          </OverlayTrigger>
        </Header>
        <Row className="d-flex flex-wrap" style={{marginTop:"10px", marginLeft:"0px", marginRight:"0px"}}>
          <Col xs={2} className="border rounded">
          <Scrollbar no_shadow="true" style={{height:"50vh", marginLeft:"-15px", marginRight:"-15px", right:"-5px"}}>
            <h4 className="text-center mt-1 me-1">Selected<OverlayTrigger
                  key={"map-icon-legend"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-map-icon-legend`}>
                      Click to see the map legend.
                    </Tooltip>
                  }
                >
                    <FontAwesomeIcon icon={faLocationQuestion} onClick={() => setShowLegendModal(true)} className="ms-1" style={{cursor:"pointer"}} />
                </OverlayTrigger></h4>
            <p className="phr" style={{marginTop:"-5px", marginBottom:"-5px", marginLeft:"10px", marginRight:"20px"}} />
            {Object.keys(totalSelectedState["ANIMALLESS"]).length > 0 ? <div className="card-header border rounded mt-3 text-center p-1" style={{paddingRight:"15px", paddingLeft:"15px", marginLeft:"8px", marginRight:"18px", marginBottom:"-4px"}}>
              <p className="mb-2" style={{marginTop:"0px"}}>Support
                <OverlayTrigger
                  key={"selected-animal-less"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-selected-animal-less`}>
                      Support Request
                    </Tooltip>
                  }
                >
                  <span className="fa-layers ms-1 me-1">
                    <FontAwesomeIcon icon={faCircle} color="grey" transform={"grow-1 right-1"} />
                    <FontAwesomeIcon icon={faLocationCrosshairs} className="icon-border" color="white" />
                  </span>
                </OverlayTrigger>
              </p>
              <p className="phr mt-1 mb-1"/>
              {Object.keys(totalSelectedState["ANIMALLESS"]).map(key => (
                <div key={key} style={{textTransform:"capitalize", marginTop:"5px"}}>{prettyText(key.split(',')[0], totalSelectedState["ANIMALLESS"][key], species)}</div>
              ))}
            </div> : ""}
            {Object.keys(totalSelectedState["REPORTED"]).length > 0 ? <div className="card-header border rounded mt-3 text-center" style={{paddingRight:"15px", paddingLeft:"15px", marginLeft:"8px", marginRight:"18px", marginBottom:"-4px"}}>
              <p className="mb-2" style={{marginTop:"-5px"}}>Reported
                <OverlayTrigger
                  key={"selected-reported"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-selected-reported`}>
                      Reported
                    </Tooltip>
                  }
                >
                  <span className="fa-layers ms-1 me-1">
                    <FontAwesomeIcon icon={faCircle} color="white" />
                    <FontAwesomeIcon icon={faExclamationCircle} className="icon-border" color="#ff4c4c" />
                  </span>
                </OverlayTrigger>
              </p>
              <p className="phr mt-1 mb-1"/>
              {Object.keys(totalSelectedState["REPORTED"]).map(key => (
                <div key={key} style={{textTransform:"capitalize", marginTop:"5px", marginBottom:"-5px", marginLeft:"-15px", marginRight:"-15px"}}>{prettyText(key.split(',')[0], totalSelectedState["REPORTED"][key], species)}</div>
              ))}
            </div> : ""}
            {Object.keys(totalSelectedState["REPORTED (EVAC REQUESTED)"]).length > 0 ? <div className="card-header border rounded mt-3 text-center" style={{paddingRight:"15px", paddingLeft:"15px", marginLeft:"8px", marginRight:"18px", marginBottom:"-4px"}}>
              <p className="mb-2" style={{marginTop:"-5px", marginLeft:"-4px", marginRight:"-4px"}}>Reported (Evac)
                <OverlayTrigger
                  key={"selected-reported-evac"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-selected-reported-evac`}>
                      Reported - (Evacuation)
                    </Tooltip>
                  }
                >
                  <span className="fa-layers ms-1">
                    <FontAwesomeIcon icon={faCircle} color="white" />
                    <FontAwesomeIcon icon={faCircleBolt} className="icon-border" color="#ff4c4c" transform={'grow-2'} />
                  </span>
                </OverlayTrigger>
              </p>
              <p className="phr mt-1 mb-1"/>
              {Object.keys(totalSelectedState["REPORTED (EVAC REQUESTED)"]).map(key => (
                <div key={key} style={{textTransform:"capitalize", marginTop:"5px", marginBottom:"-5px", marginLeft:"-15px", marginRight:"-15px"}}>{prettyText(key.split(',')[0], totalSelectedState["REPORTED (EVAC REQUESTED)"][key], species)}</div>
              ))}
            </div> : ""}
            {Object.keys(totalSelectedState["REPORTED (SIP REQUESTED)"]).length > 0 ? <div className="card-header border rounded mt-3 text-center" style={{paddingRight:"15px", paddingLeft:"15px", marginLeft:"8px", marginRight:"18px", marginBottom:"-4px"}}>
              <p className="mb-2" style={{marginTop:"-5px"}}>Reported (SIP)
                <OverlayTrigger
                  key={"selected-reported-sip"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-selected-reported-sip`}>
                      Reported - (Sheltered In Place)
                    </Tooltip>
                  }
                >
                  <span className="fa-layers ms-1" >
                    <FontAwesomeIcon icon={faCircle} className="icon-border" color="#ff4c4c" transform={'grow-2'} />
                    <FontAwesomeIcon icon={faHomeAlt} style={{color:"white"}} transform={'shrink-4 left-1'} inverse />
                    <FontAwesomeIcon icon={faHomeAltReg} style={{color:"#444"}} transform={'shrink-3 left-1'} inverse />
                  </span>
                </OverlayTrigger>
              </p>
              <p className="phr mt-1 mb-1"/>
              {Object.keys(totalSelectedState["REPORTED (SIP REQUESTED)"]).map(key => (
                <div key={key} style={{textTransform:"capitalize", marginTop:"5px", marginBottom:"-5px", marginLeft:"-15px", marginRight:"-15px"}}>{prettyText(key.split(',')[0], totalSelectedState["REPORTED (SIP REQUESTED)"][key], species)}</div>
              ))}
            </div> : ""}
            {Object.keys(totalSelectedState["SHELTERED IN PLACE"]).length > 0 ? <div className="card-header border rounded mt-3 text-center" style={{paddingRight:"15px", paddingLeft:"15px", marginLeft:"8px", marginRight:"18px", marginBottom:"-4px"}}>
              <p className="mb-2" style={{marginTop:"-5px"}}>SIP
                <OverlayTrigger
                  key={"selected-sip"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-selected-sip`}>
                      Sheltered In Place
                    </Tooltip>
                  }
                >
                  <span className="fa-layers ms-1" >
                    <FontAwesomeIcon icon={faCircle} className="icon-border" color="#f5ee0f" transform={'grow-2'} />
                    <FontAwesomeIcon icon={faHomeAlt} style={{color:"white"}} transform={'shrink-3 left-1'} inverse />
                    <FontAwesomeIcon icon={faHomeAltReg} style={{color:"#444"}} transform={'shrink-3 left-1'} inverse />
                  </span>
                </OverlayTrigger>
              </p>
              <p className="ph mt-1 mb-1"/>
              {Object.keys(totalSelectedState["SHELTERED IN PLACE"]).map(key => (
                <div key={key} style={{textTransform:"capitalize", marginTop:"5px", marginBottom:"-5px", marginLeft:"-15px", marginRight:"-15px"}}>{prettyText(key.split(',')[0], totalSelectedState["SHELTERED IN PLACE"][key], species)}</div>
              ))}
            </div> : ""}
            {Object.keys(totalSelectedState["UNABLE TO LOCATE"]).length > 0 ? <div className="card-header border rounded mt-3 text-center" style={{paddingRight:"15px", paddingLeft:"15px", marginLeft:"8px", marginRight:"18px", marginBottom:"-4px"}}>
              <p className="mb-2" style={{marginTop:"-5px"}}>UTL
                <OverlayTrigger
                  key={"selected-utl"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-selected-utl`}>
                      Unable To Locate
                    </Tooltip>
                  }
                >
                  <span className="fa-layers ms-1 me-1">
                    <FontAwesomeIcon icon={faCircle} className="fa-move-up icon-border" color="white" />
                    <FontAwesomeIcon icon={faQuestionCircle} className="fa-move-up icon-border" color="#5f5fff" />
                  </span>
                </OverlayTrigger>
              </p>
              <p className="phr mt-1 mb-1"/>
              {Object.keys(totalSelectedState["UNABLE TO LOCATE"]).map(key => (
                <div key={key} style={{textTransform:"capitalize", marginTop:"5px", marginBottom:"-5px", marginLeft:"-15px", marginRight:"-15px"}}>{prettyText(key.split(',')[0], totalSelectedState["UNABLE TO LOCATE"][key], species)}</div>
              ))}
            </div> : ""}
            {Object.keys(totalSelectedState["TRANSPORT REQUESTED"]).length > 0 ? <div className="card-header border rounded mt-3 mb-2 text-center" style={{paddingRight:"15px", paddingLeft:"15px", marginLeft:"8px", marginRight:"18px", marginBottom:"-4px"}}>
              <p className="mb-2" style={{marginTop:"-5px", marginLeft:"-15px", marginRight:"-15px"}}>Transport Requested
                <OverlayTrigger
                  key={"selected-transport-requested"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-selected-transport-requested`}>
                      Transport Requested
                    </Tooltip>
                  }
                >
                  <span className="fa-layers ms-1">
                    <FontAwesomeIcon icon={faCircle} className="icon-border" color="#af7051" transform={'grow-2'} />
                    <FontAwesomeIcon icon={faReply} className="icon-border" color="white" transform={'shrink-5'} />
                  </span>
                  {/* <span className="fa-layers ms-1" >
                    <FontAwesomeIcon icon={faCircle} className="icon-border" color="#f5ee0f" transform={'grow-2'} />
                    <FontAwesomeIcon icon={faHomeAlt} style={{color:"white"}} transform={'shrink-3 left-1'} inverse />
                    <FontAwesomeIcon icon={faHomeAltReg} style={{color:"#444"}} transform={'shrink-3 left-1'} inverse />
                  </span> */}
                </OverlayTrigger>
              </p>
              <p className="phr mt-1 mb-1"/>
              {Object.keys(totalSelectedState["TRANSPORT REQUESTED"]).map(key => (
                <div key={key} style={{textTransform:"capitalize", marginTop:"5px", marginBottom:"-5px", marginLeft:"-15px", marginRight:"-15px"}}>{prettyText(key.split(',')[0], totalSelectedState["TRANSPORT REQUESTED"][key], species)}</div>
              ))}
            </div> : ""}
          </Scrollbar>
          </Col>
          <Col xs={10} className="border rounded ps-0 pe-0">
            {data.bounds ? <Map ref={mapRef} style={{marginRight:"0px"}} bounds={data.bounds.length > 1 ? data.bounds : null} center={data.bounds.length === 1 ? [data.bounds[0][0], data.bounds[0][1]] : null} boundsOptions={{padding:[10,10]}} onMoveEnd={onMove} manual_spider={true} setReportedMarkerIcon={setReportedMarkerIcon} setSIPMarkerIcon={setSIPMarkerIcon} setUTLMarkerIcon={setUTLMarkerIcon} setReturnRequestedMarkerIcon={setReturnRequestedMarkerIcon} setReportedEvacMarkerIcon={setReportedEvacMarkerIcon} setReportedSIPMarkerIcon={setReportedSIPMarkerIcon} setCheckMarkerIcon={setCheckMarkerIcon} setGrayCheckMarkerIcon={setGrayCheckMarkerIcon} setOperationsMarkerIcon={setOperationsMarkerIcon}>
              <MarkerClusterGroup maxClusterRadius={0} spiderfyDistanceMultiplier={0.9} spiderfyOnMaxZoom={true} animate={true} iconCreateFunction={(cluster) => createCustomClusterIcon(cluster)} chunkedLoading>
              {teamData.teams.filter(evac => evac.id === selectedTeam).length && teamData.teams.filter(evac => evac.id === selectedTeam)[0].service_request_objects.map(service_request => (
                <UpdateableMarker
                  key={service_request.id}
                  position={[service_request.latitude, service_request.longitude]}
                  initialIcon={grayCheckMarkerIcon}
                  checkMarkerIcon={grayCheckMarkerIcon}
                  checked={[service_request.id]}
                  service_request={service_request}
                  zIndexOffset={1}
                >
                  <MapTooltip autoPan={false}>
                    <span>
                      SR#{service_request.id_for_incident}: {service_request.full_address}
                      <div>{service_request.animal_count || 0} Animal{service_request.animal_count === 1 ? "" : "s"}</div>
                      {service_request.followup_date ? <div>Followup Date: <Moment format="L">{service_request.followup_date}</Moment></div> : ""}
                      <div>
                      {service_request.aco_required ? <img width={16} height={16} src="/static/images/badge-sheriff.png" alt="Special Handling Required" className="me-1" /> : ""}
                      {service_request.injured ? <img width={16} height={16} src="/static/images/band-aid-solid.png" alt="Injured" className="me-1" /> : ""}
                      {service_request.accessible === "yes" ? <img width={16} height={16} src="/static/images/car-solid.png" alt="Accessible" className="me-1" /> : service_request.accessible === "no" ? <img width={16} height={16} src="/static/images/car-ban-solid.png" alt="Not Acessible" className="me-1" /> : ""}
                      {service_request.turn_around === "yes" ? <img width={16} height={16} src="/static/images/trailer-solid.png" alt="Turn Around" className="me-1" /> : service_request.turn_around === "no" ? <img width={16} height={16} src="/static/images/trailer-ban-solid.png" alt="No Turn Around" className="me-1" /> : ""}
                      </div>
                    </span>
                  </MapTooltip>
                </UpdateableMarker>
              ))}
              {data.service_requests
              .filter(service_request => filterData.special_handling ? service_request.aco_required === filterData.special_handling : true)
              .filter(service_request => filterData.verbal_permission ? service_request.verbal_permission === filterData.verbal_permission : true)
              .filter(service_request => filterData.support_sr ? service_request.animals.length === 0 : true)
              .filter(service_request => filterData.medical_record ? service_request.animals.filter(animal => animal.medical_record).length > 0 : true)
              // .filter(service_request => statusOptions.hide_pending ? service_request.pending !== statusOptions.hide_pending : true)
              .filter(service_request => filterData.animal_count[0] > 0 ? service_request.animals.map(animal => animal.animal_count).sort((a,b) => a - b)[0] >= filterData.animal_count[0] : true)
              .filter(service_request => filterData.animal_count[1] > 0 ? service_request.animals.map(animal => animal.animal_count).sort((a,b) => a - b).at(-1) <= filterData.animal_count[1] : true)
              .filter(service_request => filterData.priority.length ? filterData.priority.includes(service_request.priority) : true)
              .filter(service_request => filterData.turn_around.length ? filterData.turn_around.includes(service_request.turn_around) : true)
              .filter(service_request => filterData.trailer_required.length ? filterData.trailer_required.includes(service_request.trailer_required) : true)
              .filter(service_request => filterData.accessible.length ? filterData.accessible.includes(service_request.accessible) : true)
              .filter(service_request => filterData.status.length ? service_request.animals.filter(animal => filterData.status.includes(animal.status)).length > 0 : true)
              .filter(service_request => filterData.injured.length ? service_request.animals.filter(animal => filterData.injured.includes(animal.injured)).length > 0 : true)
              .filter(service_request => filterData.confined.length ? service_request.animals.filter(animal => filterData.confined.includes(animal.confined)).length > 0 : true)
              .filter(service_request => filterData.aggressive.length ? service_request.animals.filter(animal => filterData.aggressive.includes(animal.aggressive)).length > 0 : true)
              .filter(service_request => filterData.species.length ? filterData.species.some(species => new Set(service_request.animals.filter(animal => ['REPORTED', 'REPORTED (EVAC REQUESTED)', 'REPORTED (SIP REQUESTED)', 'UNABLE TO LOCATE' , 'SHELTERED IN PLACE', 'TRANSPORT REQUESTED'].includes(animal.status)).map(animal => animal.species_string)).has(species)) || filterData.species.some(species => new Set(service_request.animals.filter(animal => ['REPORTED', 'REPORTED (EVAC REQUESTED)', 'REPORTED (SIP REQUESTED)', 'UNABLE TO LOCATE' , 'SHELTERED IN PLACE', 'TRANSPORT REQUESTED'].includes(animal.status)).map(animal => animal.category)).has(species)) : true)
              .filter(service_request => filterData.followup_date_start ? moment(service_request.followup_date).format('YYYY-MM-DD') >= filterData.followup_date_start : true)
              .filter(service_request => filterData.followup_date_end ? moment(service_request.followup_date).format('YYYY-MM-DD') <= filterData.followup_date_end : true)
              .map(service_request => (
                <span key={service_request.id}> {mapState[service_request.id] ? 
                  <UpdateableMarker
                    position={[service_request.latitude, service_request.longitude]}
                    mapState={mapState}
                    handleMapState={handleMapState}
                    service_request={service_request}
                    checked={checked}
                    initialIcon={service_request.reported_animals > 0 ? reportedMarkerIcon : service_request.reported_evac > 0 ? reportedEvacMarkerIcon : service_request.reported_sheltered_in_place > 0 ? reportedSIPMarkerIcon : service_request.sheltered_in_place > 0 ? SIPMarkerIcon : service_request.unable_to_locate ? UTLMarkerIcon : service_request.transport_requested ? returnRequestedMarkerIcon : operationsMarkerIcon}
                    checkMarkerIcon={checkMarkerIcon}
                  >
                    <MapTooltip autoPan={false}>
                      <span>
                        SR#{service_request.id_for_incident}: {service_request.full_address}
                        {mapState[service_request.id] ?
                          <span>
                            <br />
                            {Object.keys(mapState[service_request.id].matches).map((key,i) => (
                              <span key={key} style={{textTransform:"capitalize"}}>
                                {i > 0 && ", "}{prettyText(key.split(',')[0], mapState[service_request.id].matches[key], species)}
                              </span>
                            ))}
                            {Object.keys(mapState[service_request.id].matches).length === 0 ? "0 Animals" : ""}
                          </span>
                        :""}
                        {service_request.followup_date ? <div>Followup Date: <Moment format="L">{service_request.followup_date}</Moment></div> : ""}
                        <div>
                        {service_request.aco_required ? <img width={16} height={16} src="/static/images/badge-sheriff.png" alt="Special Handling Required" className="me-1" /> : ""}
                        {service_request.injured ? <img width={16} height={16} src="/static/images/band-aid-solid.png" alt="Injured" className="me-1" /> : ""}
                        {service_request.accessible === "yes" ? <img width={16} height={16} src="/static/images/car-solid.png" alt="Accessible" className="me-1" /> : service_request.accessible === "no" ? <img width={16} height={16} src="/static/images/car-ban-solid.png" alt="Not Acessible" className="me-1" /> : ""}
                        {service_request.turn_around === "yes" ? <img width={16} height={16} src="/static/images/trailer-solid.png" alt="Turn Around" className="me-1" /> : service_request.turn_around === "no" ? <img width={16} height={16} src="/static/images/trailer-ban-solid.png" alt="No Turn Around" className="me-1" /> : ""}
                        </div>
                      </span>
                    </MapTooltip>
                  </UpdateableMarker> : ""}
                </span>
              ))}
              </MarkerClusterGroup>
              {Object.entries(mapState).filter(([key, value]) => value.radius === "enabled").map(([key, value]) => (
                <Circle key={key} center={{lat:value.latitude, lng: value.longitude}} color={value.color} radius={805} interactive={false} />
              ))}
            </Map> : ""}
          </Col>
        </Row>
        <Row className="ms-0 me-0 border rounded" style={{marginTop:"-1px", marginBottom:"-1px"}}>
          <Col xs={2} className="ps-0 pe-0" style={{marginLeft:"-1px", marginRight:"1px"}}>
            <Button
              type="submit"
              className="btn-block mt-auto border w-100"
              disabled={selectedCount.count === 0 || props.isSubmitting}
            >
              {props.isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  />
                  Submitting...
                </>
              ) : (
                selectedTeam
                  ? "ASSIGN"
                  : props.values.team_members.length > 0
                    ? "DEPLOY"
                    : selectedCount.count > 0
                      ? "PREPLAN"
                      : "DEPLOY/PREPLAN"
              )}
            </Button>
          </Col>
          {/* <Col className="ps-0 pe-0 ms-1" style={{maxWidth:"170px"}}>
            <div className="card-header border rounded text-center" style={{height:"37px", marginLeft:"-6px", marginRight:"-11px", paddingTop:"6px", whiteSpace:"nowrap"}}>
              <span style={{marginLeft:"-12px"}}>{props.values.team_name || teamName}
                {!preplan ? <OverlayTrigger
                  key={"edit-team-name"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-edit-team-name`}>
                      Update team name
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faPencilAlt} className="ms-1" style={{cursor:'pointer'}} onClick={() => setShow(true)} />
                </OverlayTrigger> : ""}
              </span>
            </div>
          </Col> */}
          <Col className="flex-grow-1 col-auto pe-0" style={{marginLeft:"-2px", marginRight:"-2px", paddingLeft:"0px", paddingRight:"4px"}}>
              <Typeahead
                id="team_members"
                multiple
                onChange={(values) => handleChange(values, props)}
                selected={selected}
                options={teamData.options}
                placeholder="Choose team members..."
                style={{height:"22px"}}
                className="map-typeahead"
                renderMenuItemChildren={(option) => (
                  <div>
                    {option.label} {option.is_assigned ? <FontAwesomeIcon icon={faExclamationTriangle} size="sm" /> : ""}
                  </div>
                )}
              />
          </Col>
          <Col className="col-auto ps-0 pe-0" style={{marginTop:"-4px", marginBottom:"-4px", marginRight:"-2px"}}>
            {selectedTeam ?
            <OverlayTrigger
              key={"add-team-member-disabled"}
              placement="top"
              overlay={
                <Tooltip id={`tooltip-add-team-member-disabled`}>
                  Cannot add new team members when a team is selected.
                </Tooltip>
              }
            >
              <FontAwesomeIcon icon={faPlusSquare} className="float-end" size="3x" transform="shrink-1" style={{cursor:"not-allowed", color:'#b4b4b4', zIndex:9999}} inverse />
            </OverlayTrigger>
            : <OverlayTrigger
              key={"add-team-member"}
              placement="top"
              overlay={
                <Tooltip id={`tooltip-add-team-member`}>
                  Add a new team member
                </Tooltip>
              }
            >
              <FontAwesomeIcon icon={faPlusSquare} className="float-end" size="3x" transform="shrink-1" onClick={() => setShowAddTeamMember(true)} style={{cursor:"pointer"}} inverse />
            </OverlayTrigger>}
          </Col>
        </Row>
        <Row className="d-flex flex-wrap" style={{marginTop:"-1px", marginRight:"-23px", marginLeft:"6px", minHeight:"36vh", paddingRight:"14px"}}>
          <Col xs={2} className="d-flex flex-column card-header ps-3 pe-0 border rounded" style={{marginLeft:"-7px", marginRight:"-2px", height:"277px"}}>
            <Scrollbar no_shadow="true" style={{height:"275px", marginTop:"-5px"}} renderThumbHorizontal={props => <div {...props} style={{...props.style, display: 'none'}} />} renderThumbVertical={props => <div {...props} style={{...props.style, marginRight: '-15px'}} />}>
              <h5 className="text-center" style={{marginBottom:"-10px", marginLeft:"-10px"}}>Options
              {filterData.species.length > 0 || filterData.priority.length > 0 || filterData.turn_around.length > 0 || filterData.trailer_required.length > 0 || filterData.accessible.length > 0 || filterData.status.length > 0 || filterData.injured.length > 0 || filterData.aggressive.length > 0 || filterData.confined.length > 0 || (filterData.animal_count[0] > 0 || filterData.animal_count[1] > 0) || filterData.followup_date_start || filterData.followup_date_end || filterData.special_handling || filterData.verbal_permission || filterData.support_sr || filterData.medical_record ?
                <OverlayTrigger
                  key={"filtered"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-filtered`}>
                      Filtered options
                    </Tooltip>
                  }
                >
                  <span className="fa-layers" onClick={() => {setShowFilterModal(true)}} style={{cursor:"pointer"}}>
                    <FontAwesomeIcon icon={faFilter} className="ms-1" />
                    <FontAwesomeIcon icon={faCheckCircle} size="sm" className="fa-inverse" transform={'shrink-4 down-3 right-9'} inverse />
                  </span>
                </OverlayTrigger>
              :
                <OverlayTrigger
                  key={"filter"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-filter`}>
                      Filter options
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faFilter} className="ms-1" onClick={() => {setShowFilterModal(true)}} style={{cursor:"pointer", marginRight:"-4px"}} />
                </OverlayTrigger>
              }
              <OverlayTrigger
                key={"sort"}
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-sort`}>
                    Sort options
                  </Tooltip>
                }
              >
                <FontAwesomeIcon icon={faBarsSort} onClick={() => {setShowSortModal(true)}} style={{cursor:"pointer", marginLeft:"11px"}} transform={'grow-3'} />
              </OverlayTrigger>
              </h5>
              <p className="phr" style={{marginBottom:"5px", marginRight:"15px"}} />
              {filterData.priority.length ? <div style={{marginRight:"15px", fontSize:"14px"}}>{filterData.priority.map(priority => priorityText[priority]).join(", ")}</div> : ""}
              {filterData.priority.length && (filterData.species.length || filterData.followup_date_start || filterData.followup_date_end || filterData.special_handling || filterData.verbal_permission || filterData.support_sr || filterData.medical_record) ? <p className="phr" style={{marginTop:"5px", marginBottom:"5px", marginRight:"15px"}} /> : ""}
              {filterData.followup_date_start || filterData.followup_date_end ? <div style={{marginRight:"15px", fontSize:"14px"}}>{filterData.followup_date_start ? <Moment format="MM/DD/YY">{filterData.followup_date_start}</Moment> : "None"}{filterData.followup_date_start || filterData.followup_date_end ? " - " : ""}{filterData.followup_date_end ? <Moment format="MM/DD/YY">{filterData.followup_date_end}</Moment> : "None"}</div> : ""}
              {(filterData.followup_date_start || filterData.followup_date_end) && (filterData.species.length || filterData.special_handling) ? <p className="phr" style={{marginTop:"5px", marginBottom:"5px", marginRight:"15px", fontSize:"14px"}} /> : ""}
              {/* {filterData.species_category.length ? <div style={{textTransform:"capitalize", marginRight:"15px"}}>{filterData.species_category.join(", ")}</div> : ""} */}
              {filterData.species.length ? <div style={{textTransform:"capitalize", marginRight:"15px", fontSize:"14px"}}>{filterData.species.join(", ")}</div> : ""}
              {filterData.status.length ? <div style={{textTransform:"capitalize", marginRight:"15px", fontSize:"14px"}}>{filterData.status.map(status => altStatusLabelLookup[status]).join(", ")}</div> : ""}
              {filterData.animal_count[0] > 0 || filterData.animal_count[1] > 0 ? <div style={{marginRight:"15px", fontSize:"14px"}}>Animal Count: {filterData.animal_count[0] + '-' + (filterData.animal_count[1] === 100 ? '100+' : filterData.animal_count[1])}</div> : ""}
              {(filterData.species.length || filterData.status.length || (filterData.animal_count[0] > 0 || filterData.animal_count[1] > 0)) && (filterData.turn_around.length || filterData.trailer_required.length || filterData.accessible.length || filterData.injured.length || filterData.aggressive.length || filterData.confined.length) ? <p className="phr" style={{marginTop:"5px", marginBottom:"5px", marginRight:"15px"}} /> : ""}
              {filterData.turn_around.length ? <div style={{textTransform:"capitalize", marginRight:"15px", fontSize:"14px"}}><OverlayTrigger
                key={"turnaround"}
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-turnaround`}>
                    Room to turn around
                  </Tooltip>
                }
              >
                <FontAwesomeIcon icon={faTrailer} className="ms-1" style={{marginRight:"0px"}} />
              </OverlayTrigger>: {filterData.turn_around.join(", ")}</div> : ""}
              {filterData.trailer_required.length ? <div style={{textTransform:"capitalize", marginRight:"15px", fontSize:"14px"}}>Trailer Required: {filterData.trailer_required.join(", ")}</div> : ""}
              {filterData.accessible.length ? <div style={{textTransform:"capitalize", marginRight:"15px"}}><OverlayTrigger
                key={"accessible"}
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-accessible`}>
                    Easily accessible
                  </Tooltip>
                }
              >
                <FontAwesomeIcon icon={faCar} className="ms-1" style={{marginRight:"0px"}} />
              </OverlayTrigger>: {filterData.accessible.join(", ")}</div> : ""}
              {filterData.injured.length ? <div style={{textTransform:"capitalize", marginRight:"15px"}}><OverlayTrigger
                key={"injured"}
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-injured`}>
                    Injured
                  </Tooltip>
                }
              >
                <FontAwesomeIcon icon={faBandAid} className="ms-1" style={{marginRight:"0px"}} />
              </OverlayTrigger>: {filterData.injured.join(", ")}</div> : ""}
              {filterData.aggressive.length ? <div style={{textTransform:"capitalize", marginRight:"15px"}}><OverlayTrigger
                key={"aggressive"}
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-aggressive`}>
                    Aggressive
                  </Tooltip>
                }
              >
                <FontAwesomeIcon icon={faClawMarks} className="ms-1" style={{marginRight:"0px"}} />
              </OverlayTrigger>: {filterData.aggressive.join(", ")}</div> : ""}
              {filterData.confined.length ? <div style={{textTransform:"capitalize", marginRight:"15px"}}><OverlayTrigger
                key={"confined"}
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-confined`}>
                    Confined
                  </Tooltip>
                }
              >
                <FontAwesomeIcon icon={faLink} className="ms-1" style={{marginRight:"0px"}} />
              </OverlayTrigger>: {filterData.confined.join(", ")}</div> : ""}
              {(filterData.species.length || filterData.turn_around.length || filterData.trailer_required.length || filterData.accessible.length || filterData.injured.length || filterData.aggressive.length || filterData.confined.length || filterData.status.length) && (filterData.special_handling || filterData.verbal_permission || filterData.medical_record || filterData.support_sr) ? <p className="phr" style={{marginTop:"5px", marginBottom:"5px", marginRight:"15px"}} /> : ""}
              {filterData.special_handling ? <div style={{marginRight:"15px", fontSize:"14px"}}>Special Handling Required</div> : ""}
              {filterData.medical_record ? <div style={{marginRight:"15px", fontSize:"14px"}}>Has Medical Record</div> : ""}
              {filterData.verbal_permission ? <div style={{marginRight:"15px", fontSize:"14px"}}>Verbal Liability Release</div> : ""}
              {filterData.support_sr ? <div style={{marginRight:"15px", fontSize:"14px"}}>Support SRs Only</div> : ""}
            </Scrollbar>
          </Col>
          <Col xs={10} className="border rounded" style={{marginLeft:"1px", height:"277px", overflowY:"auto", paddingRight:"-1px"}}>
            <Scrollbar no_shadow="true" style={{height:"275px", marginLeft:"-7px", marginRight:"-7px"}} renderThumbHorizontal={props => <div {...props} style={{...props.style, display: 'none'}} />}>
              {data.service_requests
              .filter(service_request => filterData.medical_record ? service_request.animals.filter(animal => animal.medical_record).length > 0 : true)
              .filter(service_request => filterData.support_sr ? service_request.animals.length === 0 : true)
              .filter(service_request => filterData.animal_count[0] > 0 ? service_request.animals.map(animal => animal.animal_count).sort((a,b) => a - b).at(-1) >= filterData.animal_count[0] : true)
              .filter(service_request => filterData.animal_count[1] > 0 ? service_request.animals.map(animal => animal.animal_count).sort((a,b) => a - b).at(-1) <= filterData.animal_count[1] : true)
              .filter(service_request => filterData.special_handling ? service_request.aco_required === filterData.special_handling : true)
              .filter(service_request => filterData.verbal_permission ? service_request.verbal_permission === filterData.verbal_permission : true)
              // .filter(service_request => statusOptions.hide_pending ? service_request.pending !== statusOptions.hide_pending : true)
              .filter(service_request => filterData.priority.length ? filterData.priority.includes(service_request.priority) : true)
              .filter(service_request => filterData.turn_around.length ? filterData.turn_around.includes(service_request.turn_around) : true)
              .filter(service_request => filterData.trailer_required.length ? filterData.trailer_required.includes(service_request.trailer_required) : true)
              .filter(service_request => filterData.accessible.length ? filterData.accessible.includes(service_request.accessible) : true)
              .filter(service_request => filterData.status.length ? service_request.animals.filter(animal => filterData.status.includes(animal.status)).length > 0 : true)
              .filter(service_request => filterData.injured.length ? service_request.animals.filter(animal => filterData.injured.includes(animal.injured)).length > 0 : true)
              .filter(service_request => filterData.confined.length ? service_request.animals.filter(animal => filterData.confined.includes(animal.confined)).length > 0 : true)
              .filter(service_request => filterData.aggressive.length ? service_request.animals.filter(animal => filterData.aggressive.includes(animal.aggressive)).length > 0 : true)
              .filter(service_request => filterData.species.length ? (filterData.species.some(species => new Set(service_request.animals.filter(animal => ['REPORTED', 'REPORTED (EVAC REQUESTED)', 'REPORTED (SIP REQUESTED)', 'UNABLE TO LOCATE' , 'SHELTERED IN PLACE', 'TRANSPORT REQUESTED'].includes(animal.status)).map(animal => animal.species_string)).has(species)) || filterData.species.some(species => new Set(service_request.animals.filter(animal => ['REPORTED', 'REPORTED (EVAC REQUESTED)', 'REPORTED (SIP REQUESTED)', 'UNABLE TO LOCATE' , 'SHELTERED IN PLACE', 'TRANSPORT REQUESTED'].includes(animal.status)).map(animal => animal.category)).has(species))) : true)
              // .filter(service_request => filterData.species_category.length ? filterData.species_category.some(species_category => new Set(service_request.animals.filter(animal => ['REPORTED', 'REPORTED (EVAC REQUESTED)', 'REPORTED (SIP REQUESTED)', 'UNABLE TO LOCATE' , 'SHELTERED IN PLACE'].includes(animal.status)).map(animal => animal.category)).has(species_category)) : true)
              .filter(service_request => filterData.followup_date_start ? moment(service_request.followup_date).format('YYYY-MM-DD') >= filterData.followup_date_start : true)
              .filter(service_request => filterData.followup_date_end ? moment(service_request.followup_date).format('YYYY-MM-DD') <= filterData.followup_date_end : true)
              .sort((a, b) => {
                // Sort by followup_date
                if (sortChoice === 'followup_date') {
                  if (!a.followup_date && b.followup_date) return 1; // `a` is null, move it to the bottom
                  if (a.followup_date && !b.followup_date) return -1; // `b` is null, move it to the bottom
                  if (a.followup_date && b.followup_date) {
                    const dateA = new Date(a.followup_date);
                    const dateB = new Date(b.followup_date);
                    if (dateA - dateB !== 0) return dateA - dateB;
                  }

                  // Compare priority (ascending order)
                  if ((a.priority || 0) - (b.priority || 0) !== 0) return (a.priority || 0) - (b.priority || 0);

                  // Compare pk (ascending order)
                  return (a.id_for_incident || 0) - (b.id_for_incident || 0);
                }
                else {
                  // Compare priority (ascending order)
                  if ((a.priority || 0) - (b.priority || 0) !== 0) return (a.priority || 0) - (b.priority || 0);

                  if (!a.followup_date && b.followup_date) return 1; // `a` is null, move it to the bottom
                  if (a.followup_date && !b.followup_date) return -1; // `b` is null, move it to the bottom
                  if (a.followup_date && b.followup_date) {
                    const dateA = new Date(a.followup_date);
                    const dateB = new Date(b.followup_date);
                    if (dateA - dateB !== 0) return dateA - dateB;
                  }

                  // Compare pk (ascending order)
                  return (a.id_for_incident || 0) - (b.id_for_incident || 0);
                }
              })
              .map(service_request => (
                <span key={service_request.id}>{mapState[service_request.id] && (checked.includes(service_request.id) || !mapState[service_request.id].hidden) ?
                <div className="mt-1 mb-1">
                  <div className="card-header border rounded">
                    <Checkbox
                      id={String(service_request.id)}
                      name={String(service_request.id)}
                      checked={checked.includes(service_request.id)}
                      style={{
                        transform: "scale(1.25)",
                        marginLeft: "-14px",
                        marginTop: "-5px",
                        marginBottom: "-5px",
                        paddingRight:"12px"
                      }}
                      onClick={(e) => {handleMapState(e, service_request.id)}}
                    />
                    {mapState[service_request.id] ?
                    <span>
                      {Object.keys(mapState[service_request.id].matches).map((key,i) => (
                        <span key={key} style={{textTransform:"capitalize"}}>
                          {i > 0 && ", "}{prettyText(key.split(',')[0], mapState[service_request.id].matches[key], species)}
                        </span>
                      ))}
                    </span>
                    : ""}
                    {Object.keys(mapState[service_request.id].matches).length === 0 ? "0 Animals" : ""}
                    {service_request.reported_animals > 0 ?
                    <OverlayTrigger
                      key={"reported"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-reported`}>
                          {service_request.reported_animals} animal{service_request.reported_animals > 1 ? "s are":" is"} reported
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faExclamationCircle} className="ms-1"/>
                    </OverlayTrigger>
                    : ""}
                    {service_request.reported_evac > 0 ?
                    <OverlayTrigger
                      key={"reported-evac"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-reported-evac`}>
                          {service_request.reported_evac} animal{service_request.reported_evac > 1 ? "s are":" is"} reported (evac requested)
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faCircleBolt} className="ms-1"/>
                    </OverlayTrigger>
                    : ""}
                    {service_request.reported_sheltered_in_place > 0 ?
                    <OverlayTrigger
                      key={"reported-sip"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-reported-sip`}>
                          {service_request.reported_sheltered_in_place} animal{service_request.reported_sheltered_in_place > 1 ? "s are":" is"} reported (sip requested)
                        </Tooltip>
                      }
                    >
                      <span className="fa-layers ms-1">
                        <FontAwesomeIcon icon={faCircle} transform={'grow-1'} />
                        <FontAwesomeIcon icon={faHomeAlt} style={{color:"#444"}} transform={'shrink-3'} size="sm" inverse />
                      </span>
                    </OverlayTrigger>
                    : ""}
                    {service_request.sheltered_in_place > 0 ?
                    <OverlayTrigger
                      key={"sip"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-sip`}>
                          {service_request.sheltered_in_place} animal{service_request.sheltered_in_place > 1 ? "s are":" is"} sheltered in place
                        </Tooltip>
                      }
                    >
                      <span className="fa-layers ms-1">
                        <FontAwesomeIcon icon={faCircle} transform={'grow-1'} />
                        <FontAwesomeIcon icon={faHomeAlt} style={{color:"#444"}} transform={'shrink-3'} size="sm" inverse />
                      </span>
                    </OverlayTrigger>
                    : ""}
                    {service_request.unable_to_locate > 0 ?
                    <OverlayTrigger
                      key={"utl"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-utl`}>
                          {service_request.unable_to_locate} animal{service_request.unable_to_locate > 1 ? "s are":" is"} unable to be located
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} className="ms-1"/>
                    </OverlayTrigger>
                    : ""}
                    {service_request.transport_requested > 0 ?
                    <OverlayTrigger
                      key={"transport-requested"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-transport-requested`}>
                          {service_request.transport_requested} animal{service_request.transport_requested > 1 ? "s are":" is"} transport requested
                        </Tooltip>
                      }
                    >
                      <span className="fa-layers ms-1">
                        <FontAwesomeIcon icon={faCircle} transform={'grow-1'} />
                        <FontAwesomeIcon icon={faReply} style={{color:"#615e5e"}} transform={'shrink-3'} size="sm" inverse />
                      </span>
                    </OverlayTrigger>
                    : ""}
                    {service_request.priority === 1 ?
                      <OverlayTrigger
                        key={"highest"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-highest`}>
                            {priorityText[service_request.priority]} priority
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faChevronDoubleUp} color="#BF1919" className="ms-1"/>
                      </OverlayTrigger>
                    : service_request.priority === 2 ?
                      <OverlayTrigger
                        key={"high"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-high`}>
                            {priorityText[service_request.priority]} priority
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faChevronUp} className="ms-1"/>
                      </OverlayTrigger>
                    : service_request.priority === 3 ?
                      <OverlayTrigger
                        key={"medium"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-medium`}>
                            {priorityText[service_request.priority]} priority
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faEquals} className="ms-1"/>
                      </OverlayTrigger>
                    : service_request.priority === 4 ?
                      <OverlayTrigger
                        key={"low"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-low`}>
                            {priorityText[service_request.priority]} priority
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faChevronDown} className="ms-1"/>
                      </OverlayTrigger>
                    : service_request.priority === 5 ?
                      <OverlayTrigger
                        key={"lowest"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-lowest`}>
                            {priorityText[service_request.priority]} priority
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faChevronDoubleDown} className="ms-1"/>
                      </OverlayTrigger>
                    : ""}
                  { isFollowupDateBeforeToday(service_request.followup_date) ?
                     <OverlayTrigger
                        key={"followup-date"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-followup-date`}>
                            Service Request Overdue
                            Follow Up Date: <Moment format="MM/DD/YY">{service_request.followup_date}</Moment>
                          </Tooltip>
                        }
                        >
                          <span className="fa-layers ms-1">
                            <FontAwesomeIcon icon={faCalendarExclamation} color="#BF1919" className="fa-move-down" />
                          </span>
                        </OverlayTrigger>
                    : 
                    <OverlayTrigger
                       key={"followup-date"}
                       placement="top"
                       overlay={
                         <Tooltip id={`tooltip-followup-date`}>
                           Follow Up Date: <Moment format="MM/DD/YY">{service_request.followup_date}</Moment>
                         </Tooltip>
                       }
                       >
                         <span className="fa-layers ms-1">
                           <FontAwesomeIcon icon={faCalendarExclamation} className="fa-move-down" />
                         </span>
                       </OverlayTrigger>}
                    {service_request.aco_required ?
                    <OverlayTrigger
                      key={"aco"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-aco`}>
                          Special Handling Required
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faHandsHolding} className="ms-1"/>
                    </OverlayTrigger>
                    : ""}
                    {service_request.injured ?
                    <OverlayTrigger
                      key={"injured"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-injured`}>
                          Injured animal
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faBandAid} className="ms-1"/>
                    </OverlayTrigger>
                    : ""}
                    {service_request.accessible === "yes" ?
                    <OverlayTrigger
                      key={"accessible"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-accessible`}>
                          Easily accessible
                        </Tooltip>
                      }
                    >
                      <span className="fa-layers me-1">
                        <FontAwesomeIcon icon={faCar} className="ms-1 fa-move-down" />
                      </span>
                    </OverlayTrigger> : service_request.accessible === "no" ?
                    <OverlayTrigger
                      key={"not-accessible"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-not-accessible`}>
                          Not easily accessible
                        </Tooltip>
                      }
                    >
                      <span className="fa-layers ms-1">
                        <FontAwesomeIcon icon={faCar} className="fa-move-down" />
                        <FontAwesomeIcon icon={faBan} color="#ef5151" />
                      </span>
                    </OverlayTrigger>
                    : ""}
                    {service_request.turn_around === "yes" ?
                    <OverlayTrigger
                      key={"turnaround"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-turnaround`}>
                          Room to turn around
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faTrailer} className="ms-1" style={{marginRight:"-3px"}} />
                    </OverlayTrigger> : service_request.turn_around === "no" ?
                    <OverlayTrigger
                      key={"no-turnaround"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-no-turnaround`}>
                          No room to turn around
                        </Tooltip>
                      }
                    >
                      <span className="fa-layers ms-1">
                        <FontAwesomeIcon icon={faTrailer} />
                        <FontAwesomeIcon icon={faBan} color="#ef5151" transform={'right-1'} />
                      </span>
                    </OverlayTrigger>
                    : ""}
                    {service_request.directions ?
                    <OverlayTrigger
                      key={"directions"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-directions`}>
                          {service_request.directions}
                        </Tooltip>
                      }
                    >
                      <span className="fa-layers" style={{marginLeft:"7px", marginRight:"-5px"}}>
                        <FontAwesomeIcon icon={faClipboardList} />
                      </span>
                    </OverlayTrigger>
                    : ""}
                    <span className="ms-2">| SR#{service_request.id_for_incident} - <Moment format="MM/DD/YY">{service_request.followup_date}</Moment> - <Link href={"/" + organization +"/" + incident + "/hotline/servicerequest/" + service_request.id_for_incident} className="text-link" style={{textDecoration:"none", color:"white"}}>{service_request.full_address}</Link></span>
                    <OverlayTrigger
                      key={"radius-toggle"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-radius-toggle`}>
                          Toggle 1 mile radius
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faBullseye} color={mapState[service_request.id].radius === "enabled" ? "red" : ""} className="ms-1 me-1" style={{cursor:'pointer'}} onClick={() => handleRadius(service_request.id)} />
                    </OverlayTrigger>
                    {/* {service_request.followup_date ?
                    <OverlayTrigger
                      key={"followup-date"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-followup-date`}>
                          Followup date:&nbsp;<Moment format="L">{service_request.followup_date}</Moment>
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faCalendarDay} className="me-1" />
                    </OverlayTrigger> : ""} */}
                    {service_request.owner_objects.length === 0 ?
                      <OverlayTrigger
                        key={"stray"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-stray`}>
                            No owner
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faUserAltSlash} className="me-1" size="sm" />
                      </OverlayTrigger> :
                      <OverlayTrigger
                        key={"stray"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-stray`}>
                            {service_request.owner_objects.map(owner => (
                              <div key={owner.id}>Owner: {owner.first_name} {owner.last_name}</div>
                            ))}
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faUserAlt} className="me-1" size="sm" />
                      </OverlayTrigger>
                    }
                    {/* <OverlayTrigger
                      key={"add-to-dispatch"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-add-to-dispatch`}>
                          Assign service request to a field assignment
                        </Tooltip>
                      }
                    >
                      <Link href={"/" + organization +"/" + incident + "/hotline/servicerequest/" + service_request.id_for_incident + "/assign"}><FontAwesomeIcon icon={faMapMarkedAlt} inverse /></Link>
                    </OverlayTrigger> */}
                  </div>
                </div>
                : ""}
                </span>
              ))}
              <div className="card-header mt-1 mb-1 border rounded" hidden={data.service_requests.length > 0}>
                No open Service Requests found.
              </div>
            </Scrollbar>
          </Col>
        </Row>
        <DispatchDuplicateSRModal dupe_list={data.service_requests.filter(sr => duplicateSRs.includes(String(sr.id)))} sr_list={data.service_requests.filter(sr => mapState[sr.id] && checked.includes(sr.id))} show={showDispatchDuplicateSRModal} handleClose={handleCloseDispatchDuplicateSRModal} handleSubmit={props.handleSubmit} handleReselect={handleReselect} />
        <DispatchAlreadyAssignedTeamModal team_members={props.values.team_members} team_options={selected} setProceed={setProceed} show={showAlreadyAssignedTeamModal} handleClose={handleCloseAlreadyAssignedTeamModal} handleSubmit={props.handleSubmit} />
        <Modal show={showFilterModal} onHide={handleCloseFilterModal}>
          <Modal.Header closeButton>
            <Modal.Title>Filter Options</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row style={{marginTop:"-15px", marginLeft:"0px", marginRight:"0px"}}>
              <ListGroup horizontal className="border rounded w-100 pe-0" style={{height:"30px"}}>
                <Col className="rounded">
                  <ListGroup.Item active={optionFilter === 'request'} style={{textTransform:"capitalize", cursor:'pointer', paddingLeft:"5px", paddingRight:"5px"}} onClick={() => {setOptionFilter('request');}}>
                    <div className="justify-content-center d-flex align-items-center rounded" style={{marginTop:"-2px", height:"12px"}}>
                      Service Request Filters
                    </div>
                  </ListGroup.Item>
                </Col>
                <Col className="rounded">
                  <ListGroup.Item active={optionFilter === 'animal'} style={{textTransform:"capitalize", cursor:'pointer'}} onClick={() => {setOptionFilter('animal');}}>
                      <div className="justify-content-center d-flex align-items-center rounded" style={{marginTop:"-2px", marginLeft:"4px", height:"12px"}}>
                        Animal Filters
                      </div>
                  </ListGroup.Item>
                </Col>
              </ListGroup>
            </Row>
            {optionFilter === 'request' ? <>
            <label className="mt-3 mb-2">Followup Date</label>
            <Row>
              <Col>
                <DateRangePicker
                  name={`start_date_range_picker`}
                  id={`start_date_range_picker`}
                  placeholder={"Filter by Start Date"}
                  style={{height:"35px", marginRight:"-10px"}}
                  mode="single"
                  data-enable-time={false}
                  clearable={"true"}
                  ref={openStartRef}
                  onChange={(dateRange) => {
                    setStartDate(dateRange);
                    if (dateRange.length) {
                      let parsedDateRange = dateRange.toString().split(',');
                      let start_date = moment(parsedDateRange[0]).format('YYYY-MM-DD');
                      setFilterData((prevState) => ({...prevState, followup_date_start:start_date}))
                    } else {
                      setFilterData((prevState) => ({...prevState, followup_date_start:null}))
                    }
                  }}
                  value={startDate}
                />
              </Col>
              <Col>
                <DateRangePicker
                  name={`end_date_range_picker`}
                  id={`end_date_range_picker`}
                  placeholder={"Filter by End Date"}
                  style={{height:"35px", marginLeft:"-10px"}}
                  mode="single"
                  data-enable-time={false}
                  clearable={"true"}
                  ref={openEndRef}
                  onChange={(dateRange) => {
                    setEndDate(dateRange);
                    if (dateRange.length) {
                      let parsedDateRange = dateRange.toString().split(',');
                      let end_date = moment(parsedDateRange[0]).format('YYYY-MM-DD');
                      setFilterData((prevState) => ({...prevState, followup_date_end:end_date}))
                    } else {
                      setFilterData((prevState) => ({...prevState, followup_date_end:null}))
                    }
                  }}
                  value={endDate}
                />
              </Col>
            </Row>
            <label className="mt-3 mb-2">Priority</label>
            <Typeahead
              id="priority"
              multiple
              onChange={(values) => {setFilterData((prevState) => ({...prevState, priority:values.map(option => option.value)}))}}
              options={priorityChoices}
              placeholder="Choose priorities..."
              className="priority-typeahead"
              selected={priorityChoices.filter(choice => filterData.priority.includes(choice.value))}
            />
            <label className="mt-3 mb-2">Turn Around</label>
            <Typeahead
              id="turn_around"
              multiple
              onChange={(values) => {setFilterData((prevState) => ({...prevState, turn_around:values.map(option => option.value)}))}}
              options={unknownChoices}
              placeholder="Choose turn around status..."
              className="turn-around-typeahead"
              selected={unknownChoices.filter(choice => filterData.turn_around.includes(choice.value))}
            />
            <label className="mt-3 mb-2">Trailer Required</label>
            <Typeahead
              id="trailer_required"
              multiple
              onChange={(values) => {setFilterData((prevState) => ({...prevState, trailer_required:values.map(option => option.value)}))}}
              options={unknownChoices}
              placeholder="Choose trailer required status..."
              className="turn-around-typeahead"
              selected={unknownChoices.filter(choice => filterData.trailer_required.includes(choice.value))}
            />
            <label className="mt-3 mb-2">Accessible</label>
            <Typeahead
              id="accessible"
              multiple
              onChange={(values) => {setFilterData((prevState) => ({...prevState, accessible:values.map(option => option.value)}))}}
              options={unknownChoices}
              placeholder="Choose accessible status..."
              className="turn-around-typeahead mb-3"
              selected={unknownChoices.filter(choice => filterData.accessible.includes(choice.value))}
            />
            <Row className="mt-3">
              <Col>
                <label htmlFor="verbal_permission" style={{marginBottom:"-5px"}}>Verbal Liability Release</label>
                <div style={{marginLeft:"-5px"}}><Switch id="verbal_permission" name="verbal_permission" color="primary" checked={filterData.verbal_permission} onChange={() => {setFilterData((prevState) => ({...prevState, verbal_permission:!filterData.verbal_permission}))}} /></div>
              </Col>
              <Col>
                <label htmlFor="support_sr" style={{marginBottom:"-5px"}}>Support Request</label>
                <div style={{marginLeft:"-5px"}}><Switch id="support_sr" name="support_sr" color="primary" checked={filterData.support_sr} onChange={() => {setFilterData((prevState) => ({...prevState, support_sr:!filterData.support_sr}))}} /></div>
              </Col>
            </Row>
            </> :
            <>
            <Row>
              <Col>
                <label className="mt-3 mb-2">Species</label>
                <Typeahead
                  id="species"
                  multiple
                  onChange={(values) => {setFilterData((prevState) => ({...prevState, species:values.map(option => option.value)}))}}
                  options={speciesChoices}
                  placeholder="Choose species..."
                  className="species-typeahead"
                  selected={speciesChoices.filter(choice => filterData.species.includes(choice.value))}
                />
                <label className="mt-3 mb-2">Status</label>
                <Typeahead
                  id="status"
                  multiple
                  onChange={(values) => {setFilterData((prevState) => ({...prevState, status:values.map(option => option.value)}))}}
                  options={[{value:'REPORTED', label:'Reported'}, {value:'REPORTED (EVAC REQUESTED)', label:"Reported (Evac Requested)"}, {value:'REPORTED (SIP REQUESTED)', label:'Reported (SIP Requested)'}, {value:'SHELTERED IN PLACE', label:'Sheltered In Place (SIP)'}, {value:'UNABLE TO LOCATE', label:'Unable To Locate (UTL)'}, {value:'TRANSPORT REQUESTED', label:'Transport Requested'}]}
                  placeholder="Choose animal status..."
                  className="status-typeahead"
                  selected={[{value:'REPORTED', label:'Reported'}, {value:'REPORTED (EVAC REQUESTED)', label:"Reported (Evac Requested)"}, {value:'REPORTED (SIP REQUESTED)', label:'Reported (SIP Requested)'}, {value:'SHELTERED IN PLACE', label:'Sheltered In Place (SIP)'}, {value:'UNABLE TO LOCATE', label:'Unable To Locate (UTL)'}, {value:'TRANSPORT REQUESTED', label:'Transport Requested'}].filter(choice => filterData.status.includes(choice.value))}
                />
                <label className="mt-3 mb-2">Injured</label>
                <Typeahead
                  id="injured"
                  multiple
                  onChange={(values) => {setFilterData((prevState) => ({...prevState, injured:values.map(option => option.value)}))}}
                  options={[{value:'yes', label:'Yes'}, {value:'no', label:'No'}, {value:'unknown', label:'Unknown'}]}
                  placeholder="Choose injured status..."
                  className="injured-typeahead"
                  selected={[{value:'yes', label:'Yes'}, {value:'no', label:'No'}, {value:'unknown', label:'Unknown'}].filter(choice => filterData.injured.includes(choice.value))}
                />
                <label className="mt-3 mb-2">Aggressive</label>
                <Typeahead
                  id="aggressive"
                  multiple
                  onChange={(values) => {setFilterData((prevState) => ({...prevState, aggressive:values.map(option => option.value)}))}}
                  options={[{value:'yes', label:'Yes'}, {value:'no', label:'No'}, {value:'unknown', label:'Unknown'}]}
                  placeholder="Choose aggressive status..."
                  className="aggressive-typeahead"
                  selected={[{value:'yes', label:'Yes'}, {value:'no', label:'No'}, {value:'unknown', label:'Unknown'}].filter(choice => filterData.aggressive.includes(choice.value))}
                />
                <label className="mt-3 mb-2">Confined</label>
                <Typeahead
                  id="confined"
                  multiple
                  onChange={(values) => {setFilterData((prevState) => ({...prevState, confined:values.map(option => option.value)}))}}
                  options={[{value:'yes', label:'Yes'}, {value:'no', label:'No'}, {value:'unknown', label:'Unknown'}]}
                  placeholder="Choose confined status..."
                  className="confined-typeahead"
                  selected={[{value:'yes', label:'Yes'}, {value:'no', label:'No'}, {value:'unknown', label:'Unknown'}].filter(choice => filterData.confined.includes(choice.value))}
                />
              </Col>
            </Row>
            <Row className="mt-3" style={{marginLeft:"-10px"}}>
              <Col>
                <label>Animal Count</label>
                <Box sx={{ width: 300 }} style={{marginLeft:"9px"}}>
                <PrettySlider
                  getAriaLabel={() => 'Animal count'}
                  valueLabelFormat={getAriaValueText}
                  value={filterData.animal_count}
                  onChange={handleAnimalCountChange}
                  valueLabelDisplay="auto"
                  color="primary"
                  min={0}
                  marks={marks}
                  // getAriaValueText={valuetext}
                /></Box>
              </Col>
            </Row>
            <Row>
              <Col>
                <label htmlFor="special_handling" style={{marginBottom:"-5px"}}>Special Handling Required</label>
                <div style={{marginLeft:"-5px"}}><Switch id="special_handling" name="special_handling" color="primary" checked={filterData.special_handling} onChange={() => {setFilterData((prevState) => ({...prevState, special_handling:!filterData.special_handling}))}} /></div>
              </Col>
              <Col>
                <label htmlFor="medical_record" style={{marginBottom:"-5px"}}>Has Medical Record</label>
                <div style={{marginLeft:"-5px"}}><Switch id="medical_record" name="medical_record" color="primary" checked={filterData.medical_record} onChange={() => {setFilterData((prevState) => ({...prevState, medical_record:!filterData.medical_record}))}} /></div>
              </Col>
            </Row>
            </>}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {setMarks([{value: 0, label: '0'}, {value: 100, label: '100+'}]);openStartRef.current&&openStartRef.current.flatpickr.clear();openEndRef.current&&openEndRef.current.flatpickr.clear();setFilterData({priority:[], species:[], status:[], turn_around:[], trailer_required:[], accessible:[], injured:[], aggressive:[], confined:[], animal_count:[0,0], verbal: null, followup_date_start:null, followup_date_end:null, special_handling:false, verbal_permission:false, medical_record:false, support_sr:false})}}>Clear</Button>
            <Button variant="primary" onClick={handleCloseFilterModal}>Apply</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showSortModal} onHide={handleCloseSortModal}>
          <Modal.Header closeButton>
            <Modal.Title>Sort Options</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div><label>Primary Sort Method</label></div>
            <Radio
              inline
              id="primary-sort-followup-date"
              label="Followup Date"
              onClick={() => {setSortChoice('followup_date')}}
              checked={sortChoice === 'followup_date' ? true : false}
            />
            <Radio
              inline
              id="primary-sort-priority"
              label="Priority"
              style={{marginLeft:"50px"}}
              onClick={() => {setSortChoice('priority')}}
              checked={sortChoice === 'priority' ? true : false}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSortModal}>Okay</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showLegendModal} onHide={handleCloseLegendModal} dialogClassName="small-modal">
          <Modal.Header closeButton>
            <Modal.Title>Map Legend</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="fa-layers ms-1" style={{marginRight:"6px"}}>
              <FontAwesomeIcon icon={faCircle} className="fa-move-down" color="white" transform={'grow-2'} />
              <FontAwesomeIcon icon={faExclamationCircle} className="icon-border fa-move-down" color="#ff4c4c" transform={'grow-2'} />
            </div>
            Reported
            <div>
              <span className="fa-layers ms-1" style={{marginRight:"6px"}}>
                <FontAwesomeIcon icon={faCircle} className="fa-move-down" color="white" transform={'grow-2'} />
                <FontAwesomeIcon icon={faCircleBolt} className="icon-border fa-move-down" color="#ff4c4c" transform={'grow-2'} />
              </span>
              Reported (Evac Requested)
            </div>
            <div>
              <span className="fa-layers ms-1" style={{marginRight:"6px"}}>
                <FontAwesomeIcon icon={faCircle} className="icon-border fa-move-down" color="#ff4c4c" transform={'grow-2'} />
                <FontAwesomeIcon icon={faHomeAlt} className="fa-move-down" style={{color:"white"}} transform={'shrink-4'} inverse />
                <FontAwesomeIcon icon={faHomeAltReg} className="fa-move-down" style={{color:"#444"}} transform={'shrink-3'} inverse />
              </span>
              Reported (SIP Requested)
            </div>
            <div>
              <span className="fa-layers ms-1" style={{marginRight:"6px"}}>
                <FontAwesomeIcon icon={faCircle} className="icon-border fa-move-down" color="#f5ee0f" transform={'grow-2'} />
                <FontAwesomeIcon icon={faHomeAlt} className="fa-move-down" style={{color:"white"}} transform={'shrink-3'} inverse />
                <FontAwesomeIcon icon={faHomeAltReg} className="fa-move-down" style={{color:"#444"}} transform={'shrink-3'} inverse />
              </span>
            Sheltered in Place (SIP)
            </div>
            <div>
              <span className="fa-layers ms-1" style={{marginRight:"6px"}}>
                <FontAwesomeIcon icon={faCircle} className="fa-move-down" color="white" transform={'grow-2'} />
                <FontAwesomeIcon icon={faQuestionCircleDuo} className="icon-border fa-move-down" transform={'grow-2'} style={{"--fa-primary-color":'white', "--fa-secondary-color":'#5f5fff', "--fa-secondary-opacity": 1}}  />
              </span>
              Unable to Locate (UTL)
            </div>
            <div>
              <span className="fa-layers ms-1" style={{marginRight:"6px"}}>
                <FontAwesomeIcon icon={faCircle} className="icon-border fa-move-down" color="#af7051" transform={'grow-2'} />
                <FontAwesomeIcon icon={faReply} className="icon-border fa-move-down" color="white" transform={'shrink-4'} />
              </span>
              Transport Requested
            </div>
            <div>
              <span className="fa-layers ms-1" style={{marginRight:"6px"}}>
                <FontAwesomeIcon icon={faCircle} className="icon-border fa-move-down" color="grey" transform={'grow-2'} />
                <FontAwesomeIcon icon={faLocationCrosshairs} className="icon-border fa-move-down" color="white" style={{marginRight:"-1px"}} />
              </span>
              Is Support Request
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseLegendModal}>Close</Button>
          </Modal.Footer>
        </Modal>
        <FieldTeamMemberModal state={state} selected={selected} setSelected={setSelected} selectedCount={selectedCount} setSelectedCount={setSelectedCount} setFieldValue={props.setFieldValue} values={props.values} handleCloseShowAddTeamMember={handleCloseShowAddTeamMember} setShowSystemError={setShowSystemError} showAddTeamMember={showAddTeamMember} />
        {/* <Formik
          initialValues={{
            first_name: '',
            last_name: '',
            phone: '',
            agency_id: '',
            operational: state.incident.training ? false : true,
            training: state.incident.training ? true : false,
            incident: state ? state.incident.id : 'undefined',
            organization: state ? state.organization.id : 'undefined',
          }}
          enableReinitialize={true}
          validationSchema={Yup.object({
            first_name: Yup.string()
              .max(50, 'Must be 50 characters or less')
              .required('Required'),
            last_name: Yup.string()
              .max(50, 'Must be 50 characters or less')
              .required('Required'),
            phone: Yup.string()
              .matches(phoneRegex, "Phone number is not valid")
              .required('Required'),
            agency_id: Yup.string()
              .max(20, 'Must be 20 characters or less'),
          })}
          onSubmit={(values, { resetForm }) => {
            axios.post('/evac/api/evacteammember/', values)
            .then(response => {
              let selected_list = [...selected];
              selected_list.push({id:[response.data.id], label:response.data.first_name + " " + response.data.last_name + (response.data.agency_id ? " (" + response.data.agency_id + ")" : ""), is_assigned:false})
              setSelected(selected_list);
              props.setFieldValue('team_members', [...props.values.team_members, response.data.id]);
              setSelectedCount((prevState) => ({...prevState, disabled:selectedCount.count > 0 ? false : true}));
              handleCloseShowAddTeamMember();
              resetForm();
            })
            .catch(error => {
              setShowSystemError(true);
            });
          }}
        >
          {formikProps => (
            <Modal show={showAddTeamMember} onHide={handleCloseShowAddTeamMember}>
              <Modal.Header closeButton>
                <Modal.Title>Add Team Member</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <BootstrapForm>
                  <Row className="gx-2">
                    <TextInput
                      type="text"
                      label="First Name*"
                      name="first_name"
                      id="first_name"
                      xs="6"
                    />
                    <TextInput
                      type="text"
                      label="Last Name*"
                      name="last_name"
                      id="last_name"
                      xs="6"
                    />
                  </Row>
                  <Row className="mt-3 gx-2">
                    <TextInput
                      type="text"
                      label="Phone*"
                      name="phone"
                      id="phone"
                      xs="6"
                    />
                    <TextInput
                      type="text"
                      label="Agency ID"
                      name="agency_id"
                      id="agency_id"
                      xs="6"
                    />
                  </Row>
                </BootstrapForm>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={() => formikProps.submitForm()}>Save</Button>
                <Button variant="secondary" onClick={handleCloseShowAddTeamMember}>Close</Button>
              </Modal.Footer>
            </Modal>
          )}
        </Formik> */}
      </Form>
    )}
  </Formik>
  )
}

export default Deploy;
